module.exports = __webpack_public_path__ + "static/media/afl-trophy.3ee97455.png";